import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

import styles from "../statistics.module.css";
import { formatNumber } from "..";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
);
export function customTooltipHandler(context, value, percent) {
  let tooltipEl = document.getElementById("chart-tooltip");

  if (!tooltipEl) {
    tooltipEl = document.createElement("div");
    tooltipEl.id = "chart-tooltip";
    tooltipEl.className = styles.customTooltip;
    document.body.appendChild(tooltipEl);
  }

  const tooltip = context.tooltip;
  if (tooltip.opacity === 0) {
    tooltipEl.style.opacity = 0;
    return;
  }

  tooltipEl.innerHTML = `
    <div class="${styles.tooltipContent}">
      <div class="${styles.tooltipValue}">${Number(value).toFixed(
        0,
      )} / ${percent}%</div>
    </div>
  `;

  const canvasRect = context.chart.canvas.getBoundingClientRect();
  const left = canvasRect.left + window.scrollX + tooltip.caretX + 12;
  const top =
    canvasRect.top +
    window.scrollY +
    tooltip.caretY -
    tooltipEl.offsetHeight / 2;

  tooltipEl.style.opacity = 1;
  tooltipEl.style.width = "100px";
  tooltipEl.style.position = "absolute";
  tooltipEl.style.left = `${left}px`;
  tooltipEl.style.top = `${top}px`;
  tooltipEl.style.pointerEvents = "none";
}

export function OwnershipConcentration({ ownershipConcentration }) {
  const labels = [">70%", ">60%", ">50%"];

  const dataValues = [
    ownershipConcentration?.over_70.percent,
    ownershipConcentration?.over_60.percent,
    ownershipConcentration?.over_50.percent,
  ];
  const valueValues = [
    ownershipConcentration?.over_70.value,
    ownershipConcentration?.over_60.value,
    ownershipConcentration?.over_50.value,
  ];
  const barColors = ["#236192", "#418FDE", "#34B3F1"];

  const data = {
    labels,
    datasets: [
      {
        data: dataValues,
        backgroundColor: barColors,
        borderRadius: 6,
        barPercentage: 0.4,
        categoryPercentage: 0.6,
      },
    ],
  };

  const options = {
    indexAxis: "y",
    responsive: true,
    maintainAspectRatio: false,
    layout: { padding: { top: 0, bottom: 0 } },
    plugins: {
      legend: { display: false },
      tooltip: {
        enabled: false,
        external: (context) => {
          const index = context.tooltip?.dataPoints?.[0]?.dataIndex;
          if (index === undefined) return;

          const rawValue = Math.round(valueValues[index]);
          const percentValue = dataValues[index].toFixed(0);

          const formattedValue = formatNumber(rawValue);

          console.log(formattedValue, "formattedValue");
          customTooltipHandler(context, formattedValue, percentValue);
        },
      },
    },
    scales: {
      x: {
        beginAtZero: true,
        max: 100,
        ticks: {
          stepSize: 25,
          callback: (value) => `${value}`,
        },
        grid: { color: "rgba(200,200,200,0.1)" },
      },
      y: {
        grid: { color: "rgba(200,200,200,0.1)" },
      },
    },
  };

  return (
    <div className={styles.statisticsContent}>
      <h2 className={styles.statisticsTitle}>
        Ownership concentration (Addresses Holding &gt; 1%)
      </h2>
      <div className={styles.statisticsColoredBar}>
        <div
          className={styles.statisticTableWrapper}
          style={{ marginTop: "10px" }}
        >
          <div
            className={styles.statisticTableOneColumn}
            style={{ marginTop: "10px", height: "240px" }}
          >
            <Bar options={options} data={data} />
          </div>
        </div>
      </div>
    </div>
  );
}
